export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const UPDATE = 'UPDATE';
export const PATCH = 'PATCH';
